import React, { useState } from "react";
import { Box, TextField, FormHelperText } from "@mui/material";
import { NoteBlockContainer } from "../../note";
import { DynamicTextField } from "../../dynamicTextField";
import { useDevcontainer, useDevcontainerLoad } from "../../../hook/devcontainer";
import { LoadBoundary } from "../../brand/LoadBoundary";
import { DevcontainerBlock } from "../../../types/notebook/note/block/devcontainer";
import { devcontainerName, devcontainerJson } from "../../../types/devcontainer";

const isValidJson = (s: string): boolean => { try { JSON.parse(s); return true; } catch { return false; } };

export const DevcontainerBlockComponent: React.FC<{ block: DevcontainerBlock }> =
  React.memo(({ block }) => {
    const { setName, setJson } = useDevcontainer(block["devcontainer-id"]);
    const { devcontainer, status, retry } = useDevcontainerLoad(block);
    const name = devcontainerName(devcontainer);
    const json = devcontainerJson(devcontainer);
    const [draft, setDraft] = useState<string | null>(null);
    const value = draft ?? json;
    const valid = isValidJson(value);
    return (
      <NoteBlockContainer name="Devcontainer">
        <LoadBoundary
          status={status}
          onRetry={retry}
          label="Loading devcontainer"
          errorMessage="Could not load this devcontainer."
          testId="devcontainer-loading"
        >
        <Box data-testid="devcontainer-block">
          <DynamicTextField data-testid="devcontainer-name" text={name} setText={setName} placeholder="Name" />
          <TextField
            data-testid="devcontainer-json"
            value={value}
            onChange={(e) => { setDraft(e.target.value); if (isValidJson(e.target.value)) setJson(e.target.value); }}
            onBlur={() => { if (isValidJson(value)) setJson(value); setDraft(null); }}
            multiline minRows={4} fullWidth variant="outlined" error={!valid}
            placeholder="devcontainer.json"
          />
          {!valid && <FormHelperText error>Invalid JSON</FormHelperText>}
        </Box>
        </LoadBoundary>
      </NoteBlockContainer>
    );
  });
